import { render, staticRenderFns } from "./AddNewVenueTraining.vue?vue&type=template&id=5aabfc22"
import script from "./AddNewVenueTraining.vue?vue&type=script&lang=js"
export * from "./AddNewVenueTraining.vue?vue&type=script&lang=js"
import style0 from "./AddNewVenueTraining.vue?vue&type=style&index=0&id=5aabfc22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports